import styled from 'styled-components'
import { Dialog as DdsDialog, getFontStyle } from '@diversioteam/diversio-ds'

export const Dialog = styled(DdsDialog)`
    margin-left: 320px;

    .dds-dialog-title .MuiTypography-root {
        display: flex;
        gap: 20px;

        ${getFontStyle('p01Medium')}
    }

    .dds-dialog-content.MuiDialogContent-root {
        padding-left: 110px;
        color: ${({ theme }) => theme.colors.secondary500};

        ${getFontStyle('p02Regular')}
    }
`

export const IconWrapper = styled.span`
    display: flex;
    flex: 0 0 40px;
    width: 40px;
    height: 40px;
    display: flex;
    align-items: center;
    justify-content: center;
    border-radius: 50%;
    background-color: ${({ theme }) => theme.colors.tangerineSharp};
`
